import { Navigate } from 'react-router';

import { ANY_SPORT_MARKET } from '@sorare/core/src/constants/__generated__/routes';
import { useEnableSorare27Nav } from '@sorare/core/src/hooks/useEnableSorare27Nav';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { NewSeasonPage } from '@sorare/gameplay/src/components/new-season/NewSeasonPage';

const NewSeason = () => {
  const {
    flags: { use2027LaunchPage = false },
  } = useFeatureFlags();
  const enableSorare27Nav = useEnableSorare27Nav();

  if (!use2027LaunchPage || !enableSorare27Nav)
    return <Navigate to={ANY_SPORT_MARKET} replace />;

  return <NewSeasonPage />;
};

export default NewSeason;
